import buildings from '../../mock/buildings.json'

import { UPDATE_BUILDINGS } from '../actions/buildings'

let initialBuildings = buildings
if(localStorage.getItem('EHPBuildings')) {
    initialBuildings = JSON.parse(localStorage.getItem('EHPBuildings'))
}

const reducer = (state = initialBuildings, action) => {
    switch (action.type) {
        case UPDATE_BUILDINGS:
            return action.buildings
        default:
            return state
    }
}

export default reducer